import { Component, HostListener } from "@angular/core"

@Component({
    selector: 'app-screen-size-aware',
    template: '',
    standalone: false
})
export class ScreenSizeAwareComponent {
    screenWidth: number = 0
    screenHeight: number = 0

    constructor() {
        this.getScreenSize()
    }

    @HostListener('window:resize', ['$event'])
    getScreenSize() {
        this.screenHeight = window.innerHeight
        this.screenWidth = window.innerWidth
    }
}